<template>
    <div class="mt-5">
        <load-screen-component></load-screen-component>
        <div class="d-flex flex-row pt-3">
            <h4 class="pt-3 mr-2">
                Dashboard Propostas Loteamento:
            </h4>
            <div class="d-flex flex-row">
                <Select2
                        class="align-self-center"
                        v-model="allotmentId" :options="allotments" @select="changeAllotment($event)"
                        :settings="{width:'13vw'}" placeholder="Selecione"
                ></Select2>
            </div>
        </div>
        <div class="card pr-3 pl-3 pt-2">
            <div class="row gutters">
                <h4 class="col-12"><i class="icon-layers2"></i> Propostas</h4>
                <div class="col-6  d-flex flex-wrap">
                    <div class="d-flex flex-column p-3 flex-grow-1 col-12 proposal-dashboard-moment-card">
                        <h5 class="font-weight-bold">
                            {{ t('DASHBOARD_PROPOSAL.NOW_MOMENT') }}
                        </h5>
                        <div class="row gutters mt-4 p-2 pt-5">
                            <div class="col-6 pointer">
                                <h2 class="font-weight-bold pl-1"> {{allByStatus['EM AVALIAÇÃO']}} </h2>
                                <h6 class="mt-1"><i
                                        class="icon-schedule"></i> {{ t("DASHBOARD_PROPOSAL.IN_AVALIATION") }}</h6>
                            </div>
                            <div class="col-6 pointer">
                                <h2 class="font-weight-bold pl-1">{{allByStatus['PENDENTE']}}</h2>
                                <h6 class="mt-1"><i
                                        class="icon-warning1"></i> {{ t("DASHBOARD_PROPOSAL.PENDING") }}</h6>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6  d-flex flex-wrap">
                    <div class="d-flex flex-column p-3 flex-grow-1 col-12 proposal-dashboard-status-card">
                        <h5 class="font-weight-bold">
                            {{ t('DASHBOARD_PROPOSAL.QTD_BY_STATUS') }}
                        </h5>
                        <div id="graficQtdProposalStatus"></div>
                    </div>
                </div>
                <div class="col-12 pt-1 d-flex flex-row justify-content-end">
                    <h5 class="mr-4">Total: {{totalProposal}}</h5>
                </div>
            </div>
        </div>
        <div class="card">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="pt-3 row">
                    <div class="col-2"></div>
                    <div class="col-12 d-flex flex-row justify-content-center">
                        <h5 class="card-title">
                            {{ this.t('DASHBOARD_PROPOSAL.PROGRESS_ADD_PROPOSAL') }}
                        </h5>
                    </div>
                    <div class="main-container col-12" :class="loadChartStatus ? 'filterBlur' : ''"
                         style="height: 40vh">
                        <div id="chartProgressAdd"></div>
                    </div>
                </div>
            </div>
            <div class=" col-12 d-flex justify-content-center w-100 pb-3">
                <div class="btn btn-primary mr-2"
                     :class="grapicDay ?'' :'active'"
                     @click="mountGraficProgressByAdd();grapicDay = false">
                    <i v-if="!grapicDay"
                       class="icon-check-circle">
                    </i>
                    {{ t('DASHBOARD_PROPOSAL.LAST_12_MONTHS') }}
                </div>
                <div class="btn btn-primary "
                     @click="mountGraficProgressByAdd(true);grapicDay = true"
                     :class="grapicDay ?'active' :''">
                    <i v-if="grapicDay"
                       class="icon-check-circle">
                    </i>
                    {{ t('DASHBOARD_PROPOSAL.LAST_30_DAYS') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {useToast} from 'vue-toastification';
import {useI18n} from 'vue-i18n';
import loadScreenComponent from '../../components/layouts/loadScreenComponent';
import * as ApexCharts from "apexcharts";
import Dashboard from '../../services/Dashboard';
import StatusProposal from '../../mixins/StatusProposal';
import Select2 from 'vue3-select2-component';
import {mapState} from 'vuex';
import UserCompanies from '../../services/UserCompanies';

export default {
    name: "dashboardComponent",
    components: {
        loadScreenComponent,
        Select2,
    },
    beforeRouteLeave(to, from, next) {
        this.chartGraphicStatus?.destroy();
        this.chartQtsByStatus?.destroy();
        return next();
    },
    unmounted() {
        this.chartGraphicStatus?.destroy();
        this.chartQtsByStatus?.destroy();
    },
    mixins:[StatusProposal],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast}
    },
    data() {
        return {
            allotmentId: null,
            loadChartStatus: false,
            chartGraphicStatus: null,
            chartQtsByStatus: null,
            totalProposal: 0,
            allByStatus: {},
        }
    },
    computed:{
        ...mapState({
            allotments: 'allotments',
        })
    },
    mounted() {
        if (!sessionStorage.getItem('allotmentIdScope')) {
            this.$router.push({name: 'IndexProposal'})
        }
        this.allotmentId = sessionStorage.getItem('allotmentIdScope');
        this.mountGraficProposalByStatus();
        this.mountGraficProgressByAdd();
    },
    methods: {
        async changeAllotment({id}){
            sessionStorage.removeItem('allotmentIdScope');
            sessionStorage.setItem('allotmentIdScope', id);
            await this.chanceCustomScope(id);
            this.$router.go();
        },
        async chanceCustomScope(id) {
            await UserCompanies.chanceCustomScope(id).then(resp => {
                this.$setCustomToken(resp.data.accessToken, resp.data.refreshToken);
            }).catch(err => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(err);
            });
        },
        mountGraficProgressByAdd(days = null)
        {
            this.loadChartStatus = true
            Dashboard.getProgressProposalAdd(this.allotmentId, days).then(resp => {
                let seriesStatus = [];
                let colors = [];
                let categories = resp.data.categories;
                delete resp.data.categories;
                Object.keys(resp.data).forEach(k => {
                    seriesStatus.push({
                        name: this.translateStatus(k),
                        data: resp.data[k],
                    })
                    colors.push(this.translateColorStatus(k));
                })
                let chartOptionsStatus = {
                    chart: {
                        height: '100%',
                        type: 'area',
                        width: '100%',
                        defaultLocale: 'pt',
                        locales: [{
                            name: 'pt',
                            options: {
                                toolbar: {
                                    download: 'Download SVG',
                                    selection: 'Selecionar',
                                    selectionZoom: 'Selecionar Zoom',
                                    zoomIn: 'Aumentar Zoom',
                                    zoomOut: 'Reduzir Zoom',
                                    pan: 'Panorama',
                                    reset: 'Resetar Zoom',
                                }
                            }
                        }]
                    },
                    responsive: [
                        {
                            breakpoint: 1000,
                            options: {
                                legend: {
                                    position: "bottom"
                                }
                            }
                        }
                    ],
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center',
                    },
                    noData: {
                        text: 'Nenhum dado para ser carregado',
                        align: 'center',
                        verticalAlign: 'middle',
                    },
                    series: seriesStatus,
                    xaxis: {
                        convertedCatToNumeric: false,
                        categories: categories
                    },
                    colors: colors,
                };
                let elChartAssign = document.getElementById('chartProgressAdd');
                this.chartGraphicStatus?.destroy();
                this.chartGraphicStatus = new ApexCharts(elChartAssign, chartOptionsStatus);
                this.chartGraphicStatus.render();
                this.loadChartStatus = false
            })
        },
        mountGraficProposalByStatus() {
            Dashboard.getQtdProposalByStatus(this.allotmentId).then((resp) => {
                this.allByStatus = resp.data;
                this.totalProposal = 0;
                let data = [];
                let categoryx = [];
                let colors = [];
                Object.keys(resp.data).forEach(s => {
                    this.totalProposal += resp.data[s];
                    switch (s){
                        case 'APROVADA':
                            data.push(resp.data[s]);
                            categoryx.push('Aprovadas');
                            colors.push(this.translateColorStatus('APROVADA'));
                            break;
                        case 'REJEITADA':
                            data.push(resp.data[s]);
                            categoryx.push('Rejeitadas');
                            colors.push(this.translateColorStatus('REJEITADA'));
                            break;
                        case 'VENDA CANCELADA':
                            data.push(resp.data[s]);
                            categoryx.push(['Venda', 'Cancelada']);
                            colors.push(this.translateColorStatus('VENDA CANCELADA'));
                            break;
                        case 'EXPIRADA':
                            data.push(resp.data[s]);
                            categoryx.push('Expiradas');
                            colors.push(this.translateColorStatus('EXPIRADA'));
                            break;
                        case 'CANCELADA':
                            data.push(resp.data[s]);
                            categoryx.push('Canceladas');
                            colors.push(this.translateColorStatus('CANCELADA'));
                            break;
                    }
                });
                var options = {
                    series: [{
                        data: data
                    }],
                    chart: {
                        height: '100%',
                        type: 'bar',
                    },
                    colors: colors,
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            borderRadius: 6,
                            borderRadiusApplication: 'end',
                            distributed: true,
                            dataLabels: {
                                position: 'top',
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        offsetY: -20,
                        formatter: function (_, { dataPointIndex }) {
                            return data[dataPointIndex];
                        },
                        style: {
                            fontSize: '12px',
                            colors: ['#000']
                        }
                    },
                    legend: {
                        show: false
                    },
                    xaxis: {
                        categories: categoryx,
                        labels: {
                            style: {
                                fontSize: '12px'
                            }
                        }
                    },
                    yaxis: {
                        min: 0,
                        max: function (max) {
                            return Math.max(max + 1, 1);
                        },
                        forceNiceScale: true,
                        decimalsInFloat: 0,
                        labels: {
                            formatter: function (value) {
                                return parseInt(value);
                            }
                        }
                    }
                };
                this.chartQtsByStatus?.destroy();
                this.chartQtsByStatus = new ApexCharts(document.querySelector("#graficQtdProposalStatus"), options);
                this.chartQtsByStatus.render();
            })
        }
    }
}
</script>

<style scoped>
.filterBlur {
    filter: blur(5px)
}
</style>
